import { handleActions } from 'redux-actions';
import { showFormulaPanelAction } from 'store/actions/formula-actions';

export default handleActions(
  {
    [showFormulaPanelAction]: (state, { payload }) => {
      return payload;
    },
  },
  false,
);
